import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import tz from 'dayjs/plugin/timezone';
import { Owner } from '../helpers/owner.decorator';
dayjs.extend(utc);
dayjs.extend(tz);

@Owner('CodeBusters')
@Pipe({
    name: 'tzDate',
    standalone: true
})
export class DateByTimeZonePipe implements PipeTransform {
    transform(value: Date | string, timezone: string = '', format: string = 'MM/DD/YYYY h:mmA'): string {
        if (!value) {
            return '';
        }

        if (timezone === '') {
            return dayjs.utc(value).format(format);
        }

        return dayjs.utc(value).tz(timezone).format(format);
    }
}
